import images from "./images";

const portfolio = [ 
    {
        id: 1,
        image: images.portfolio1,
        title: "Executive Lease",
        details: {
            date: "April 5, 2025",
            client: "Corporate Executives & Business Travelers",
            category: "Corporate Rentals",
            duration: "Monthly & Annual Plans",
            location: "Nationwide",
            cost: "Custom Business Pricing",
            projectLead: "Michael Johnson"
        },
        paragraphs: [
            "Our Executive Lease service is designed for professionals who require long-term, premium transportation solutions. We offer high-end vehicles, including luxury sedans and SUVs, tailored for corporate needs and extended use.",
            "Ideal for business executives, frequent travelers, or companies offering mobility perks to employees, our leases combine comfort, prestige, and flexibility. With customizable plans, responsive support, and top-tier vehicle options, you stay focused on business while we handle the ride."
        ],
        gallery: [
            images.portfolio1Gallery1,
            images.portfolio1Gallery2,
            images.portfolio1Gallery3,
            images.portfolio1Gallery4,
            images.portfolio1Gallery5,
            images.portfolio1Gallery6,
        ],
        challenges: [
            "Inflexible long-term rental agreements",
            "Limited vehicle options for executives",
            "Unpredictable maintenance schedules",
            "Lack of personalized customer support"
        ],
        solutions: [
            "Flexible lease durations to suit business needs",
            "Fleet of executive-class vehicles available",
            "Routine inspections and preventive maintenance",
            "Dedicated account support and priority service"
        ],
        results: [
            "Improved transportation convenience for corporate clients",
            "Higher satisfaction through tailored lease terms",
            "Reliable and consistent executive mobility",
            "Professional image reinforced with luxury vehicles"
        ]
    },
    {
        id: 2,
        image: images.portfolio2,
        title: "Gala Ride",
        details: {
            date: "May 12, 2025",
            client: "Celebrities & VIP Guests",
            category: "Event Rentals",
            duration: "Single Event Hire",
            location: "Citywide Coverage",
            cost: "Luxury Event Pricing",
            projectLead: "Sophia Turner"
        },
        paragraphs: [
            "Make a grand entrance with our Gala Ride service, offering a selection of premium vehicles perfect for red carpet events, galas, and award shows. From sleek sedans to head-turning convertibles, we ensure you arrive in style.",
            "Tailored for celebrities, influencers, and VIP guests, our service delivers not only luxury, but professionalism and punctuality. With on-demand chauffeurs and pristine vehicles, we make your spotlight moment unforgettable."
        ],
        gallery: [
            images.portfolio2Gallery1,
            images.portfolio2Gallery2,
            images.portfolio2Gallery3,
            images.portfolio2Gallery4,
            images.portfolio2Gallery5,
            images.portfolio2Gallery6,
        ],
        challenges: [
            "Demand for stylish, premium vehicles during high-profile events",
            "Tight event schedules and transportation delays",
            "Need for flawless vehicle presentation",
            "Lack of specialized chauffeurs for gala occasions"
        ],
        solutions: [
            "Fleet of red carpet-ready luxury cars",
            "Timely and coordinated pickup/drop-off services",
            "Meticulous vehicle detailing before each event",
            "Trained chauffeurs for high-profile clients"
        ],
        results: [
            "Memorable arrivals that match the occasion’s prestige",
            "Seamless and stress-free event transport",
            "Increased client satisfaction and repeat bookings",
            "Enhanced brand image for event organizers and guests"
        ]
    },
    {
        id: 3,
        image: images.portfolio3,
        title: "Staff Shuttle",
        details: {
            date: "June 6, 2025",
            client: "Corporate Offices & Industrial Parks",
            category: "Corporate Rentals",
            duration: "Daily or Monthly Service",
            location: "Urban & Suburban Routes",
            cost: "Custom Corporate Plans",
            projectLead: "Daniel Brooks"
        },
        paragraphs: [
            "Our Staff Shuttle service offers a reliable and efficient transportation solution for businesses seeking to move employees comfortably and safely between locations. Ideal for daily commutes, shift changes, or off-site operations, this service minimizes lateness and increases team productivity.",
            "We provide modern, air-conditioned vehicles with professional drivers, scheduled according to your business needs. Whether it’s a small office team or a large workforce, our tailored shuttle services ensure smooth and punctual travel every day."
        ],
        gallery: [
            images.portfolio3Gallery1,
            images.portfolio3Gallery2,
            images.portfolio3Gallery3,
            images.portfolio3Gallery4,
            images.portfolio3Gallery5,
            images.portfolio3Gallery6,
        ],
        challenges: [
            "Employee delays due to unreliable public transport",
            "High costs of individual travel reimbursements",
            "Safety and convenience concerns for night shifts",
            "Need for consistent and scalable staff mobility"
        ],
        solutions: [
            "Dedicated shuttle vehicles on optimized routes",
            "Cost-effective transportation packages",
            "GPS tracking and professional drivers for safety",
            "Custom schedules that match company operations"
        ],
        results: [
            "Improved employee punctuality and satisfaction",
            "Reduced absenteeism and transportation costs",
            "Stronger corporate reputation for employee care",
            "Scalable solution for growing teams"
        ]
    },
    {
        id: 4,
        image: images.portfolio4,
        title: "Airport Pickup",
        details: {
            date: "March 16, 2025",
            client: "Frequent Travelers & Business Guests",
            category: "Airport Services",
            duration: "24/7 Availability",
            location: "Major Airports Nationwide",
            cost: "Transparent Flat Rates",
            projectLead: "Sarah Mitchell"
        },
        paragraphs: [
            "Our Airport Pickup service ensures a smooth and stress-free arrival experience. Whether you're flying in for business, a family trip, or a special event, our drivers will be there on time with comfortable vehicles and courteous service.",
            "With real-time flight tracking, professional chauffeurs, and well-maintained cars, we take the hassle out of airport transfers. Enjoy a reliable and punctual pickup every time—no delays, no confusion, just seamless travel from the runway to your destination."
        ],
        gallery: [
            images.portfolio4Gallery1,
            images.portfolio4Gallery2,
            images.portfolio4Gallery3,
            images.portfolio4Gallery4,
            images.portfolio4Gallery5,
            images.portfolio4Gallery6,
        ],
        challenges: [
            "Unreliable airport transport services",
            "Delays due to flight changes and traffic",
            "Lack of communication and coordination",
            "Poor first impressions for corporate guests"
        ],
        solutions: [
            "Real-time flight monitoring for schedule accuracy",
            "Trained chauffeurs with meet & greet service",
            "Luxury and economy vehicles for all needs",
            "Streamlined coordination and live support"
        ],
        results: [
            "Punctual and hassle-free airport pickups",
            "Greater customer satisfaction and trust",
            "Improved convenience for international guests",
            "Professional, polished first impression"
        ]
    },
    {
        id: 5,
        image: images.portfolio5,
        title: "Wedding Car",
        details: {
            date: "May 22, 2025",
            client: "Brides, Grooms & Event Planners",
            category: "Event Rentals",
            duration: "Hourly / Full-Day Packages",
            location: "Citywide & Destination Weddings",
            cost: "Custom Luxury Packages",
            projectLead: "Ava Reynolds"
        },
        paragraphs: [
            "Our Wedding Car service adds a touch of elegance and class to your special day. Choose from our premium fleet of luxury cars and limousines, meticulously maintained to deliver unforgettable entrances and exits for the bride, groom, or entire wedding party.",
            "We provide fully decorated vehicles, professional chauffeurs, and on-time service to make your wedding transport seamless and stress-free. Whether it's a grand arrival or a romantic getaway car, we make every ride as memorable as the ceremony itself."
        ],
        gallery: [
            images.portfolio5Gallery1,
            images.portfolio5Gallery2,
            images.portfolio5Gallery3,
            images.portfolio5Gallery4,
            images.portfolio5Gallery5,
            images.portfolio5Gallery6
        ],
        challenges: [
            "Last-minute vehicle changes or delays",
            "Mismatch between wedding themes and cars",
            "Unprofessional drivers during formal events",
            "Lack of decoration or personalization"
        ],
        solutions: [
            "Pre-booked and guaranteed luxury models",
            "Custom decoration and theme matching",
            "Experienced chauffeurs in formal attire",
            "Flexible packages with advance coordination"
        ],
        results: [
            "Picture-perfect wedding arrivals and departures",
            "Stress-free transport planning on big day",
            "Enhanced elegance and luxury experience",
            "Happy clients and lasting photo memories"
        ]
    },
    {
        id: 6,
        image: images.portfolio6,
        title: "Business Ride",
        details: {
            date: "June 10, 2025",
            client: "Executives & Corporate Clients",
            category: "Airport Services",
            duration: "On-Demand & Scheduled Rides",
            location: "Major Airports & Business Districts",
            cost: "Corporate Pricing Available",
            projectLead: "Daniel Carter"
        },
        paragraphs: [
            "Our Business Ride service offers timely, professional, and comfortable transportation tailored for executives and business travelers. Whether it’s a ride to or from the airport or daily transfers between meetings, our premium sedans and courteous chauffeurs ensure a smooth, productive journey.",
            "Designed with corporate needs in mind, we provide Wi-Fi-enabled vehicles, punctual pickups, and quiet interiors for uninterrupted work on the go. With flexible scheduling and account management options, our service supports the pace and professionalism your business demands."
        ],
        gallery: [
            images.portfolio6Gallery1,
            images.portfolio6Gallery2,
            images.portfolio6Gallery3,
            images.portfolio6Gallery4,
            images.portfolio6Gallery5,
            images.portfolio6Gallery6
        ],
        challenges: [
            "Unreliable transport impacting meeting schedules",
            "Lack of business-friendly vehicle amenities",
            "Inconsistent quality in airport transfers",
            "Difficulty managing recurring bookings"
        ],
        solutions: [
            "Guaranteed punctual pickups and drop-offs",
            "Executive vehicles with power, Wi-Fi & comfort",
            "Trained chauffeurs with airport protocol experience",
            "Corporate accounts with easy recurring scheduling"
        ],
        results: [
            "Improved business travel efficiency",
            "Higher satisfaction for corporate clients",
            "Time-saving transfers with productivity support",
            "Professional image reinforced through elite service"
        ]
    }

];

export default portfolio;